import { HeroSection } from '../features/landing/ui/HeroSection'
import { IntelligenceMap } from '../features/landing/ui/IntelligenceMap'
import { CoverageSection } from '../features/landing/ui/CoverageSection'
import { FeaturesSection } from '../features/landing/ui/FeaturesSection'
import { AnalyticsPreviewSection } from '../features/landing/ui/AnalyticsPreviewSection'
import { UseCasesSection } from '../features/landing/ui/UseCasesSection'
import { PricingSection } from '../features/landing/ui/PricingSection'
import { LandingFrame } from '../features/landing/ui/LandingFrame'

export function LandingPage() {
  return (
    <LandingFrame>
      <HeroSection />
      <IntelligenceMap />
      <CoverageSection />
      <FeaturesSection />
      <AnalyticsPreviewSection />
      <UseCasesSection />
      <PricingSection />
    </LandingFrame>
  )
}
